<template lang="pug">
  .podcastinfo(@click="setPodcastData()")
    .col1
      font-awesome-icon.icon(:icon="['fas', 'play-circle']")
    .col2
      h3
        small {{block.attrs.undertitle}}
        | {{block.attrs.title}}
      p.by(v-if="block.attrs.author" v-html="block.attrs.author")
        //- strong  {{block.attrs.author}}
      p.desc(v-html="block.attrs.description")


</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    block: Object
  },
  methods: {
    setPodcastData(){
      const podcastobj = {
        opened: true,
        running: true,
        url: this.block.attrs.src,
        title: this.block.attrs.title,
        artist: this.block.attrs.author
      }
      this.setPodcast(podcastobj)
    },
    ...mapActions([
      'setPodcast'
    ])
  }
}
</script>
<style lang="scss" scoped>
  .podcastinfo{
    cursor: pointer;
    max-width: $overwidth;
    margin-left: auto;
    margin-right: auto;
    display: grid;
    grid-template-columns: 136px auto;
    padding: 0.5rem;
    grid-gap: 0.5rem;
    font-family: 'LaTercera', sans-serif;
    background-color: black;
    position: relative;
    transition: all 0.3s;
    &:hover{
      background: linear-gradient(90deg, #30a3e5, #e9008b);
    }
    &::after{
      content:  '';
      background: linear-gradient(90deg, #30a3e5,  #e9008b);
      position: absolute;
      top: -3px;
      bottom: -3px;
      right: -3px;
      left: -3px;
      z-index: -1;
    }
    h3,
    p{ //reset
      padding: 0;
      max-width: none;
      text-indent: 0;
      font-size: 1.2rem;
    }
    h3{
      text-transform: uppercase;
      font-size: 2.2rem;
      padding-top: 10px;
      small{
        display: block;
        padding: 2px 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 13px;
        letter-spacing: 0.5px;
        // text-transform: uppercase;
        margin: 0;
        color: #ddd;
        &::before{
          content: "\25B2";
          display: inline-block;
          margin-right: 4px;
          color: #ddd;
        }
      }
    }
  }
  .col1{
    // border: 1px solid #f0f;
    padding: 0.5rem;
  }
  .col2{
    padding: 0.5rem;
  }
  .icon{
    width: 120px;
    height: 120px;
  }
</style>
